$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('sale-support-faq')) {
    customElements.define(
      'sale-support-faq',
      class SaleSupportFaq extends HTMLElement {
        constructor() {
          super();
          this.handleResize = this.handleResize.bind(this);
          this.bindEvents();
        }

        connectedCallback() {
          this.init();
        }
        init() {
          const faqCategoryList = this.querySelector('.faq-category-list');
          const dataFaqIds = this.querySelectorAll('[data-faq-id]');
          dataFaqIds.forEach((item) => {
            item.addEventListener('click', () => {
              dataFaqIds.forEach((el) => {
                el.dataset.active = 'false';
              });
              item.dataset.active = 'true';
              this.handleCategoryClick(item);
              const itemOffset = item.offsetLeft;
              const listWidth = faqCategoryList.offsetWidth;
              const itemWidth = item.offsetWidth;
              const centerOffset = (listWidth - itemWidth) / 2;
              faqCategoryList.scrollTo({
                left: itemOffset - centerOffset,
                behavior: 'smooth',
              });
            });
          });
          const dataChildIds = this.querySelectorAll('[data-child-id]');
          const faqCategoryChildList = this.querySelector('.faq-category-child-list');
          dataChildIds.forEach((item) => {
            item.addEventListener('click', () => {
              dataChildIds.forEach((el) => {
                el.dataset.active = 'false';
              });
              item.dataset.active = 'true';
              this.handleChildClick(item);
              const itemOffset = item.offsetLeft;
              const listWidth = faqCategoryChildList.offsetWidth;
              const itemWidth = item.offsetWidth;
              const centerOffset = (listWidth - itemWidth) / 2;
              faqCategoryChildList.scrollTo({
                left: itemOffset - centerOffset,
                behavior: 'smooth',
              });
            });
          });
        }
        handleChildClick(item) {
          const dataChildId = item.getAttribute('data-child-id');
          const allDataQuestionIds = this.querySelectorAll('[data-question-id]');
          allDataQuestionIds.forEach((el) => {
            el.classList.add('hidden');
          });
          const dataQuestionId = this.querySelectorAll(`[data-question-id="${dataChildId}"]`);
          dataQuestionId.forEach((el) => {
            el.classList.remove('hidden');
          });
        }
        handleCategoryClick(item) {
          const dataFaqId = item.getAttribute('data-faq-id');
          const allDataFaqChild = this.querySelectorAll('[data-faq-child]');
          allDataFaqChild.forEach((el) => {
            el.dataset.active = 'false';
            el.classList.add('hidden');
          });

          const dataQuestionIds = this.querySelectorAll('[data-question-id]');
          dataQuestionIds.forEach((el) => {
            el.classList.add('hidden');
          });

          const dataFaqChild = this.querySelectorAll(`[data-faq-child="${dataFaqId}"]`);
          if (dataFaqChild.length > 0) {
            dataFaqChild[0].dataset.active = 'true';
            dataFaqChild.forEach((el) => {
              el.classList.remove('hidden');
            });
            const dataQuestionId = this.querySelectorAll(
              `[data-question-id="${dataFaqChild[0].getAttribute('data-child-id')}"]`
            );
            dataQuestionId.forEach((el) => {
              el.classList.remove('hidden');
            });
          }
        }

        bindEvents() {
          window.addEventListener('resize', this.handleResize);
          const faqList = this.querySelector('.faq-list');
          faqList.addEventListener('click', this.handleClick.bind(this));
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.handleResize);
          const faqList = this.querySelector('.faq-list');
          faqList.removeEventListener('click', this.handleClick.bind(this));
        }

        handleClick(event) {
          if (event.target.closest('.pq-global-faq__answer')) {
            return;
          }
          const item = event.target.closest('.pq-global-faq__item');
          const trigger = item.querySelector('.pq-global-faq__trigger');
          const ariaExpanded = this.querySelectorAll('[aria-expanded="true"]');
          ariaExpanded.forEach((el) => {
            if (el === item) {
              return;
            }
            const answer = el.querySelector('.pq-global-faq__answer');
            if (answer) {
              answer.style.height = '0px';
            }
            el.removeAttribute('aria-expanded');
          });
          this.toggleFAQ(trigger);
        }

        toggleFAQ(trigger) {
          const item = trigger.closest('.pq-global-faq__item');
          const answer = trigger.nextElementSibling;

          // 切换当前FAQ的状态
          const currentHeight = parseInt(answer.style.height) || 0;
          if (currentHeight > 0) {
            answer.style.height = '0px';
            item.removeAttribute('aria-expanded');
          } else {
            answer.style.height = 'auto';
            const height = answer.offsetHeight;

            answer.style.height = '0px';
            requestAnimationFrame(() => {
              answer.style.height = height + 'px';
              item.setAttribute('aria-expanded', 'true');
            });
          }
        }

        handleResize() {
          const expandedItems = this.querySelectorAll('.pq-global-faq__item[aria-expanded="true"]');
          expandedItems.forEach((item) => {
            const answer = item.querySelector('.pq-global-faq__answer');
            if (answer) {
              answer.style.height = 'auto';
              const realHeight = answer.offsetHeight;
              answer.style.height = realHeight + 'px';
            }
          });
        }
      }
    );
  }
});
